import React from 'react';
import { useTranslation } from 'react-i18next';
import { MailIcon } from './MailIcon';
import styles from './EmptyWorkOrderState.scss';

export const EmptyWorkOrderState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.emptyBlock}>
      <MailIcon />
      <p className={styles.title}>{t('No requests available')}</p>
      <p className={styles.subTitle}>
        {t('shared.integrations.vantify.emptyState.subtitle')}
      </p>
    </div>
  );
};

